module.exports = __webpack_public_path__ + "static/media/FB5@2x.87e321c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/FB/FB5@2x.png
// module id = 641
// module chunks = 0